export const AppConstants = {
  // App Constants
  firstDayOfWeek: 1, // Monday
  defaultLocale: 'de-DE',
  trialPeriodInDays: 99999,
  oneDayInMs: 86400000, // 24 * 60 * 60 * 1000,
  defaultActivityDurationMinutes: 60,
  defaultColorDarkModePrimary: '#FE9A00',
  defaultColorLightModePrimary: '#00786f',
} as const;

// Field Lengths
export const EMAIL_MAX_LENGTH = 100;
export const SUBDOMAIN_MAX_LENGTH = 60;
export const SUBDOMAIN_MIN_LENGTH = 4;
